<template>
    <div class="card">
        <div class="card-header">
            <div class="card-header-buttons">
                <button type="button" class="btn btn-primary" @click="saveData()">
                    <font-awesome-icon icon="check"/>
                    <span>{{t('Save')}}</span>
                </button>
            </div>
            {{t('Permissions')}}
        </div>
        <div class="card-body text-center" v-if="loading === true">
            <loading size="xs" class="mb-1"/>
            {{t('Loading')}}
        </div>
        <div class="card-body" v-if="loading === false">
            <template v-for="(items, itemName) in groups">
                <h2 class="h3">{{t(itemName)}}</h2>
                <table class="table table-bordered">
                    <tr>
                        <th>{{t('Name')}}</th>
                        <th style="width: 80px;">{{t('All')}}</th>
                        <th style="width: 80px;">{{t('Create')}}</th>
                        <th style="width: 80px;">{{t('Update')}}</th>
                        <th style="width: 80px;">{{t('Read')}}</th>
                        <th style="width: 80px;">{{t('Delete')}}</th>
                    </tr>
                    <tr v-for="item in items">
                        <td>{{item.name}}</td>

                        <td colspan="5" v-if="item.allowedCrud !== true">
                            <switchField :value="areActiveAll(item.id)"
                                         v-on:change="changedPermission(item, 'CRUD', $event)"
                            />
                        </td>
                        <template v-if="item.allowedCrud === true">
                            <td>
                                <switchField :value="areActiveAll(item.id)" v-on:change="toggleAll(item, $event)"/>
                            </td>
                            <td>
                                <switchField :value="isActive(item.id, 'C')"
                                             v-on:change="changedPermission(item, 'C', $event)"
                                />
                            </td>
                            <td>
                                <switchField :value="isActive(item.id, 'R')"
                                             v-on:change="changedPermission(item, 'R', $event)"
                                />
                            </td>
                            <td>
                                <switchField :value="isActive(item.id, 'U')"
                                             v-on:change="changedPermission(item, 'U', $event)"
                                />
                            </td>
                            <td>
                                <switchField :value="isActive(item.id, 'D')"
                                             v-on:change="changedPermission(item, 'D', $event)"
                                />
                            </td>
                        </template>
                    </tr>
                </table>
            </template>
        </div>
    </div>
</template>
<script>
    import switchField from '../../../../admin/Components/AclSwitch';
    import Loading from '../../../../core/Components/loading';

    export default {
        components: {Loading, switchField},
        created() {
            this.initAcl();
        },
        computed: {
            groups() {
                return this.$store.state.acl.items;
            }
        },
        methods: {
            saveData() {
                this.loading = true;
                this.$store.dispatch('users/update', this.$store.state.users.item).then(response => {
                    this.loading = false;
                    this.$store.dispatch('alert/success', 'User permissions was updated');
                }).catch(error => {
                    this.loading = false;
                    this.$store.dispatch('alert/warning', error.data.status);
                });
            },
            isActive(itemId, type) {
                return this.$store.getters['users/itemPermission'](itemId, type);
            },
            areActiveAll(itemId) {
                return this.$store.getters['users/itemPermission'](itemId, 'C')
                    && this.$store.getters['users/itemPermission'](itemId, 'R')
                    && this.$store.getters['users/itemPermission'](itemId, 'U')
                    && this.$store.getters['users/itemPermission'](itemId, 'D');
            },
            toggleAll(item, value) {
                this.changedPermission(item, 'C', value);
                this.changedPermission(item, 'R', value);
                this.changedPermission(item, 'U', value);
                this.changedPermission(item, 'D', value);
            },
            changedPermission(item, type, value) {
                this.$store.commit('users/changePermission', {item, type, value});
            },
            initAcl() {
                this.$store.dispatch('acl/list').then(response => {
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                });
            }
        },
        data() {
            return {
                loading: true,
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/users/manage/Permissions.vue